module.exports = __webpack_public_path__ + "static/img/right1.49809f70.png";